import React from 'react'
import { useTranslation } from 'react-i18next'
import { TooltipList } from 'packages/ui/Graph'
import { formatBandwidth } from '../../../../utils/helpers'
import { CustomTooltipProps } from '../../../../utils/types'
import { DOWNLOAD_COLOR, UPLOAD_COLOR } from '../../../../utils/constants'

const BandwidthTooltip: React.FC<CustomTooltipProps> = ({ active, label, payload }) => {
  const { t } = useTranslation()
  if (!active || !payload || !payload.length) return null

  const download = payload.find(({ dataKey }) => dataKey === 'download')
  const upload = payload.find(({ dataKey }) => dataKey === 'upload')
  const dataPoint = payload[0]?.payload

  const downloadValue = typeof download?.value === 'number' ? download.value : undefined
  const uploadValue = typeof upload?.value === 'number' ? upload.value : undefined

  return (
    <TooltipList
      title={dataPoint?.formattedTime || label}
      list={[
        {
          color: DOWNLOAD_COLOR,
          label: t('wan.graphs.bandwidth.download'),
          value: formatBandwidth(downloadValue, false, false)
        },
        {
          color: UPLOAD_COLOR,
          label: t('wan.graphs.bandwidth.upload'),
          value: formatBandwidth(uploadValue, false, false)
        },
      ]}
    />
  )
}

export default BandwidthTooltip
